<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">Two Worlds Collide</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-3"><a href="#/text/ch003#acknowledgement">Acknowledgement</a></li>
<li id="toc-li-4"><a href="#/text/ch004#foreword">Foreword</a></li>
<li id="toc-li-5"><a href="#/text/ch005#chapter-1-my-war-the-beginning">Chapter 1:  My War – The Beginning</a></li>
<li id="toc-li-6"><a href="#/text/ch006#chapter-2-training">Chapter 2:  Training</a></li>
<li id="toc-li-7"><a href="#/text/ch007#chapter-3-minesweeping-queensborough-4-april-1943">Chapter 3:  Minesweeping – Queensborough (4 April 1943)</a></li>
<li id="toc-li-8"><span href="#/text/ch008#chapter-4-interim-period-between-minesweeping-and-russian-convoys" title="Link target outside of Sample">Chapter 4:  Interim Period Between Minesweeping and Russian Convoys</span></li>
<li id="toc-li-9"><span href="#/text/ch009#chapter-5-hms-alnwick-castle-from-july-1944" title="Link target outside of Sample">Chapter 5:  HMS Alnwick Castle (From July 1944)</span>
</li>
<li id="toc-li-13"><span href="#/text/ch010#u-425-the-fate-of-a-u-boat-in-the-arctic-ocean" title="Link target outside of Sample">U-425 The Fate of a U-Boat in the Arctic Ocean</span></li>
<li id="toc-li-14"><span href="#/text/ch011#in-memory-of-my-comrades-from-u-425-who-perished-in-the-arctic-ocean" title="Link target outside of Sample">In Memory of My Comrades from U-425 Who Perished in the Arctic Ocean</span>
</li>
<li id="toc-li-30"><span href="#/text/ch013#my-account-of-the-sinking-of-u-425-by-hms-alnwick-castle-on-16-february-1945" title="Link target outside of Sample">Appendix:   My Account of the Sinking of U-425 by HMS Alnwick Castle on 16 February 1945</span>
</li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?40f5c7fe